(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/racing/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/templates/racing/assets/javascripts/init.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function (svs) {
  'use strict';

  svs.templates = svs.templates || {};
  svs.templates.racing = svs.templates.racing || {};
  svs.templates.racing.init = function () {
    if (svs.utils.ns.isNamespace('svs.templates.racing.data.heroConfig')) {
      const options = svs.templates.racing.data.heroConfig;
      svs.racing.high_five_next_race.init(_objectSpread(_objectSpread({}, options), {}, {
        el: $('.racing-hero-banner-container')
      }));
    }
  };
  if (svs.core.detect.formfactor.mobile()) {
    ReactDOM.render( React.createElement(svs.racing.streamplayer.StreamPlayer, {
      isStartPage: true
    }), document.getElementById('js-myPlayer'));
  } else {
    ReactDOM.render( React.createElement(svs.racing.streamplayerDesktopStartPageHeader.DesktopStartpageHeaderContainer, null), document.getElementById('js-myPlayer'));
  }
  new svs.templates.racing.init();
})(svs);

 })(window);